import { useMutation } from "@tanstack/react-query";
import api from "../../services/api";

export const useMacroRemove = () => {
  return useMutation({
    mutationFn: async (id) => {
      const res = await api.delete(`/macros/delete/${id}`);
      return res.data;
    },
  });
};